import { FeatureItem } from 'components';
import { JSX } from 'react';

import { Text } from '@videoblocks/design-system';

import { FeatureIcon } from '../FeatureIcon';

interface PlanFeatureItemProps {
    feature: FeatureItem;
}

export const PlanFeatureItem = ({ feature }: PlanFeatureItemProps): JSX.Element | null => {
    if (!feature.name) {
        return null;
    }

    return (
        <div className="flex gap-4 items-center">
            <div className="basis-0 flex gap-4 grow items-center min-w-0 min-h-px">
                <FeatureIcon isAvailable={feature.isAvailable} />
                <Text asChild fontSize="sm" fontWeight="regular" className="m-0">
                    <span className={`${feature.isAvailable ? 'text-gray-900' : 'text-gray-400'}`}>{feature.name}</span>
                </Text>
            </div>
        </div>
    );
};
